import { html } from 'lit';
import { List } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-list')
export class PdsIconList extends PdsIcon {
  @state()
  icon = List;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
